module.exports = __webpack_public_path__ + "img/part1-4.522d1dea.png";